import { InjectionToken } from '@angular/core';
export const HOST_ID = new InjectionToken<string>('host');
